import Trackers from './tracker/tracker';
const trackers = new Trackers();

var pushNewCartItem = function(productId, quantity) {
    var ajaxData = {
        productId: productId,
        quantity: quantity
    };
    $.ajax({
        url: '/ajax/action/basket_add_popup/get_data_layer/',
        type: 'post',
        async: false,
        data: ajaxData,
        success: function(result) {
            if (result.data.productData !== undefined) {
                trackers.onAddToCart({
                    fbpixel: {
                        content_name: result.data.productData.name,
                        value: result.data.productData.price
                    },
                    gtm: {
                        ecommerce: {
                            add: {
                                products: [result.data.productData]
                            }
                        }
                    }
                });
            }
        },
        error: function() {
            console.log('Error getDataLayer');
        }
    });
};

window.pushNewCartItem = pushNewCartItem;



// WEBPACK FOOTER //
// ./blocks/data-layer-cart.js